export type MentionFragment =
  | { type: 'text'; content: string }
  | { type: 'mention'; userId: string; displayName: string };

const MENTION_REGEX = /<@([^|]+)\|([^>]+)>/g;

export function parseMentions(text: string): MentionFragment[] {
  const fragments: MentionFragment[] = [];
  let lastIndex = 0;

  for (const match of text.matchAll(MENTION_REGEX)) {
    const matchStart = match.index!;

    if (matchStart > lastIndex) {
      fragments.push({ type: 'text', content: text.slice(lastIndex, matchStart) });
    }

    fragments.push({
      type: 'mention',
      userId: match[1],
      displayName: match[2],
    });

    lastIndex = matchStart + match[0].length;
  }

  if (lastIndex < text.length || fragments.length === 0) {
    fragments.push({ type: 'text', content: text.slice(lastIndex) });
  }

  return fragments;
}

export function formatMentionToken(staff: {
  id: string;
  firstName: string;
  lastName: string;
  degree: string | null;
}): string {
  const displayName = staff.degree
    ? `${staff.firstName} ${staff.lastName}, ${staff.degree}`
    : `${staff.firstName} ${staff.lastName}`;
  return `<@${staff.id}|${displayName}>`;
}

export function deserializeMentionText(text: string): {
  displayText: string;
  mentions: Array<{ id: string; displayText: string }>;
} {
  const mentions: Array<{ id: string; displayText: string }> = [];
  const displayText = text.replace(MENTION_REGEX, (_match, userId, displayName) => {
    const mentionDisplay = `@${displayName}`;
    mentions.push({ id: userId, displayText: mentionDisplay });
    return mentionDisplay;
  });
  return { displayText, mentions };
}

export function extractMentionedUserIds(text: string): string[] {
  const fragments = parseMentions(text);
  const ids = new Set<string>();
  for (const f of fragments) {
    if (f.type === 'mention') {
      ids.add(f.userId);
    }
  }
  return Array.from(ids);
}
